module.exports = __webpack_public_path__ + "img/dataplatform.1460587b.jpg";